var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVip = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2007_2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2007_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3175L22.2222 0L44.4444 10.3175L39.6825 35.7143L22.2222 50L4.7619 35.7143L0 10.3175Z",
    fill: "#0E1010"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.3184 10.8965L38.7656 35.1709L22.2217 48.707L5.67773 35.1709L1.125 10.8965L22.2217 1.10254L43.3184 10.8965Z",
    stroke: "#323232",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7802 32H12.4441C12.1767 32 12.0115 31.8677 11.9487 31.6033L8.0314 17.4433C7.93715 17.1478 8.05504 17 8.38537 17H10.0608C10.3125 17 10.462 17.1323 10.5092 17.3967L13.5532 29.5739H13.6476L16.6681 17.3967C16.731 17.1323 16.8882 17 17.1399 17H18.7917C19.1222 17 19.248 17.1478 19.1693 17.4433L15.2286 31.6033C15.1657 31.8677 15.0163 32 14.7802 32ZM23.7636 17.3967V31.6033C23.7636 31.8677 23.6299 32 23.3625 32H21.8759C21.6084 32 21.4746 31.8677 21.4746 31.6033V17.3967C21.4746 17.1323 21.6084 17 21.8759 17H23.3625C23.6299 17 23.7636 17.1323 23.7636 17.3967ZM29.2129 32H27.7263C27.4589 32 27.3251 31.8677 27.3251 31.6033V17.3967C27.3251 17.1323 27.4589 17 27.7263 17H33.3423C34.4907 17 35.3875 17.3189 36.0325 17.9565C36.6774 18.5786 37 19.4651 37 20.616V23.0419C37 24.1773 36.6774 25.0638 36.0325 25.7015C35.3875 26.339 34.4907 26.6579 33.3423 26.6579H29.8972C29.7084 26.6579 29.614 26.7357 29.614 26.8911V31.6033C29.614 31.8677 29.4804 32 29.2129 32ZM29.8736 24.6517H33.012C34.1289 24.6517 34.6874 24.0762 34.6874 22.9254V20.7091C34.6874 19.5584 34.1289 18.9829 33.012 18.9829H29.8736C29.7005 18.9829 29.614 19.0608 29.614 19.2163V24.4184C29.614 24.5739 29.7005 24.6517 29.8736 24.6517Z",
    fill: "#2D5EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2007_2",
    x: 0,
    y: 0,
    width: 44.4443,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2007_2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 50,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vip.6ffcc738ab5305c21aa481c09a0139ec.svg";